import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M27.978 20.886v10.025a3.99 3.99 0 0 1-7.98.001l.008-10.027a3.987 3.987 0 0 1 7.972.001Zm-12 0v10.025a3.99 3.99 0 0 1-7.98.001l.008-10.027a3.987 3.987 0 0 1 7.972.001Zm24 0v10.025a3.99 3.99 0 0 1-7.98.001l.008-10.027a3.987 3.987 0 0 1 7.972.001ZM44 39.896l.002 1.19a3 3 0 0 1-2.716 2.993 182.012 182.012 0 0 1-34.569 0 3 3 0 0 1-2.715-2.981L4 39.908A3 3 0 0 1 6.995 36.9H41a3 3 0 0 1 3 2.994Zm.006-27.518v.034a2.498 2.498 0 0 1-2.498 2.498 17725.251 17725.251 0 0 0-34.992 0 2.508 2.508 0 0 1-2.51-2.506v-.045a3 3 0 0 1 2.098-2.861l16.989-5.359a3 3 0 0 1 1.807 0l17.01 5.378a3 3 0 0 1 2.096 2.86Z",
      clipRule: "evenodd"
    }
  )
);
var SvgCompanyFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var CompanyFilled_default = SvgCompanyFilled;

export { CompanyFilled_default as default };
